import { useState, useRef, Fragment } from "react";
import Config from "../../Config";

import PlTitle from "../../elements/PlTitle";
import InputPagger from "../../helpers/InputPagger";

import InputComboGrupa from "../../helpers/InputComboGrupa";

import InputTextAlpha from "../../helpers/InputTextAlpha";
import InputComboRok from "../../helpers/InputComboRok";
import InputComboMiesiac from "../../helpers/InputComboMiesiac";
import InputComboStawkiWyz from "../../helpers/InputComboStawkiWyz";


import Csv from "../../exporter/Csv";
import Print from "../../exporter/Print";
import HtmlToPDF from "../../exporter/HtmlToPDF";


import XDateFee from "./XDateFee";
import AppContext from "../../AppContext";
import Xlsx from "../../exporter/Xlsx";
import FormatDecimal from "../../helpers/FormatDecimal";
import InputCombo from "../../helpers/InputCombo";
import InputLegend from "../../helpers/InputLegend";

function FreePl(props)
{
    const tabRef = useRef(0);
    const tab2Ref = useRef(0);    


    const [refreshView, setRefreshView] = useState(props.userData.refreshView);

    const [groups, setGroups] = useState(null);

    const [filter, setFilter] = useState(null);
    const [filterParam, setFilterParam] = useState({
        d_imie_nazwisko: props.mainView.readFilter('d_imie_nazwisko',''),        
        p_grupa_id: props.mainView.readFilter('p_grupa_id','_x_'),
        rok: (new Date()).getFullYear() ,
        miesiac: (new Date() ).getMonth()+1,
        p_typy_oplat_id: props.mainView.readFilter('p_typy_oplat_id','_x_'),
        archiwalne: "0",
        limit: 50,
        page: 1,
        pages: 1,
        show: true, 
    });
    const [tab, setTab] = useState(null);




        const [optionArch, setOptionArch]  = useState([
        {
            v: '_x_',
            title: ' - - - '
        },
        {
            v: '0',
            title: 'Dziecko aktywne'
        }, {
            v: '1',
            title: 'Dziecko w archiwum'
        }
    ]
    );


    
      const [legend, setLegend] = useState([
        {
            cls:'e_nb',
            title: 'Obecne w placówce',
            filter: {  filed: "col_none", set: "1", typ: "combo"  },
        },
        {
            cls:'e_ob',
            title: 'Nieobecne w placówce',
            filter: {  filed: "col_none", set: "1", typ: "combo"  },
        },
    ]);




    var dt = new Date();
    const [showDay, setShowDay] = useState({
        from: dt.getDate() - 3,
        to: dt.getDate() + 3,
    });
    const [strToDay, setStrToDate] = useState( dt.toISOString().split`T`[0]  ); 

 

    const getGroup = () => {
       
 
        props.mainView.setProgress(-2);

       

        fetch( Config.url + '/rest_v1_kids,gr', {
            method: 'POST', 
            body: JSON.stringify(filterParam), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {
                        setGroups(res.result);    
                        
                        if(res.result.length > 1)
                        {
                            setFilterParam(  {...filterParam, ["p_grupa_id"]: res.result[1].v  } );
                            //console.log('GrupaXXX',  res.result[1].v );
                        }
                               
                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
         });
                   

         return false;
    }

    const getTab = () => {
       
 
        props.mainView.setProgress(-2);

       

        fetch( Config.url + '/rest_v1_kids,free_pl', {
            method: 'POST', 
            body: JSON.stringify(filterParam), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {
                        setTab(res.result);                               
                        if(res.pages != undefined )setFilterParam( {...filterParam,   ['pages']: res.pages  } );             
                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
         });
                   

         return false;
    }



    
    const valChangeListener = (filedName, val, correct, msg) => {

       // console.log("valChangeListener: " + filedName + " " + val + ", correct: " + correct + ", msg: " + msg);

        setFilterParam( {...filterParam, [filedName]:val,  [filedName+"_valid"]:correct } );
        
        if(   (val.length == 0 || val.length > 2 || msg =='combo')  && filterParam[filedName] != val )
            {
                    var defTimeOut = 1000;
                    if(msg == 'combo') defTimeOut = 10;
                    clearTimeout(AppContext.timeoutId);
                    AppContext.timeoutId = setTimeout( () => {
                        setTab(null); 
                    } , defTimeOut );
            }

        props.mainView.writeFilter(filedName, val);
    }


    const goNextNew = () => {
        console.log("goNext");    
        setTab(null);    
    }




     const filterView = () => {
        setFilterParam(  {...filterParam, ["show"]:!filterParam.show } );
    }


    const filterClear = () => {
        setFilterParam({
            d_imie_nazwisko: '',     
            p_grupa_id: '_x_',
            rok: (new Date()).getFullYear() ,
            miesiac: (new Date() ).getMonth()+1,   
            p_typy_oplat_id: '_x_',      
            archiwalne: "0",  
            limit: 50,
            page: 1,
            show: true,
        });
        setTab(null);

        props.mainView.writeFilter('d_imie_nazwisko', '');    
    }

    const filterApprove = () => {   
        setTab(null)     
    }


    const onChangePagger = (x_limit, x_page) => {

        setFilterParam(  {...filterParam, ["limit"]:x_limit, ["page"]:x_page} );
        setTab(null);
    }




       if(groups == null)
    {
        setGroups([])
        getGroup();        
    }

    if(groups == null ||  groups.length < 1) //najpierw pobierz grupy...
    {
        return <div>             
        </div>
    }


    if(tab == null)
        {
            setTab([]);
            getTab();
         
    
            return <div>
                ...
            </div>
        }

    if(refreshView != props.userData.refreshView)
        {         
            setRefreshView( props.userData.refreshView);
            setGroups(null);
            setTab(null);           
        }




           var titleRaport = filterParam.rok + "-" +  filterParam.miesiac;
    
    if(filterParam.p_grupa_id == "_x_") titleRaport += " wszystkie grupy";

    if(filterParam.p_grupa_id != '_x_')
    {
        for(var k=0; k < groups.length; k++)
        {
            if(groups[k].v == filterParam.p_grupa_id)
            {
                titleRaport +=  " " + groups[k].title;
            }
        }
    }



    


    var date = new Date();
    var toDateYMD = date.toISOString().slice(0,10);





      const zmienStatus = (e) => {
       

        //dzien={dd.dzien} p_typy_oplat_id={dd.p_typy_oplat_id}  p_dziecko_id={dd.p_dziecko_id} 


        var dzien = e.target.getAttribute('dzien');
        var p_typy_oplat_id = e.target.getAttribute('p_typy_oplat_id');
        var p_dziecko_id = e.target.getAttribute('p_dziecko_id');


        var req = {
            dzien: dzien,
            p_typy_oplat_id: p_typy_oplat_id,
            p_dziecko_id: p_dziecko_id, 
        };

     
      
 
        props.mainView.setProgress(-2);

       

        fetch( Config.url + '/rest_v1_kids,free_change2', {
            method: 'POST', 
            body: JSON.stringify(req), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {
                       getTab();           
                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
         });
                   

         return false;
    }









    return  <div className="view_content">


            {
                    filterParam.show == false  &&
                    <div className="  goright link_color" onClick={filterView}>
                        pokaż filtry
                    </div>
            } 


            {
                    filterParam.show == true  &&
                    <div className="table_filter">
               
                             <div className="filter_controll">   
                                <label>Grupa: </label>                             
                                <InputComboGrupa   userData={props.userData}  mainView={props.mainView}  value={filterParam.p_grupa_id}   valChange={valChangeListener} goNext={goNextNew} name="p_grupa_id" placeholder={"Grupa: "}   />
                            </div> 



               
                           <div className="filter_controll">   
                                <label>Dziecko: </label>                             
                                <InputTextAlpha   userData={props.userData} value={filterParam.d_imie_nazwisko}   valChange={valChangeListener} goNext={goNextNew} name="d_imie_nazwisko" placeholder={"Dziecko: "}   />
                            </div>  

                            <div className="filter_controll">   
                                    <label>Archiwum: </label>                             
                                    <InputCombo   userData={props.userData} value={filterParam.archiwalne} items={optionArch}  valChange={valChangeListener} goNext={goNextNew} name="archiwalne" placeholder={"Archiwalne: "}   />
                            </div> 
  

                            <div className="filter_controll">   
                                <label>Rok: </label>                             
                                <InputComboRok   userData={props.userData}  mainView={props.mainView}  value={filterParam.rok}   valChange={valChangeListener} goNext={goNextNew} name="rok" placeholder={": "}  noempty="1"   />
                            </div> 

                            <div className="filter_controll">   
                                <label>Miesiąc: </label>                             
                                <InputComboMiesiac   userData={props.userData}  mainView={props.mainView}  value={filterParam.miesiac}   valChange={valChangeListener} goNext={goNextNew} name="miesiac" placeholder={": "}  noempty="1"   />
                            </div> 


                          

                            <div className="filter_btn">
                                <span className="link_color" onClick={filterView}>&nbsp;ukryj filtry&nbsp;</span> 
                                <span className="btn" onClick={filterApprove} >filtruj</span>&nbsp;&nbsp;<span className="btn" onClick={filterClear} >wyczyść</span>
                            </div>

            </div>
            } 
 
       


             <div className="table_widget">                                                                        
                    <HtmlToPDF tabRef={tabRef} userData={props.userData} mainView={props.mainView}  orientation="landscape" title={"Nieobecności w pl. " + titleRaport } />                                    

                    <Csv tabRef={tab2Ref} title={"Nieobecności w pl. "  + titleRaport } />
                    <Xlsx tabRef={tab2Ref}  title={"Nieobecności w pl. " + titleRaport } />

                    <Print tabRef={tab2Ref} title={"Nieobecności w pl. " + titleRaport }  />

                    <InputLegend items={legend}  valChange={valChangeListener} />

            </div>



            <div className="scorll_x">



                            <div ref={tabRef} className="gohide">
                                <h3>Nieobecności {filterParam.rok + "-" + filterParam.miesiac }</h3>   
                                        <table className="table" ref={tab2Ref} >
                                            <thead>
                                                    <tr className="header">
                                                        <td className="td_left">LP</td>                                                 
                                                        <td>Dziecko</td>  
                                                        
                                                       

                                                        {
                                                            tab.map( (row, ix) => {

                                                                if(ix > 0) return null;

                                                                return (
                                                                    row.dni.map( (dd, id) => {
                                                                        return (
                                                                            <td>{id+1}</td>
                                                                        )
                                                                    } )
                                                                )
                                                              

                                                            } )
                                                        }

                                                        <td>NB</td>
                                                        <td>OB</td>
                                                     

                                                    </tr>
                                                </thead>
                                                
                                                <tbody>

                                                        {
                                                  

                                                            tab.map( (row, ix) => {

                                                                var razemNB = 0;
                                                                var razemOB = 0;       
                                                                
                                                                var iloscRoz   = 0;
                                                                var razemKwota = 0;


                                                                var rowStyle = " row ";
                                                                if(ix % 2 == 0 )rowStyle = " row2 ";


                                                                return (
                                                                    <tr className={rowStyle}>
                                                                        <td className="gocenter">{ix+1}</td>                                                  
                                                                        <td>{row.nazwisko + " " + row.imie}</td>                                                                     
                                                                      
                                                                        {
                                                                            row.dni.map( (dd, id) => {

                                                                                var clsTD = " e_square_center ";
                                                                                var clsSquare = "e_ob_def";

                                                                                var infoDay = "Dzień: " + dd.dzien + "<br/><br/>";


                                                                                 if(dd.w == '6')      clsTD ="e_square_center e_squere_sb";
                                                                                 if(dd.w == '0')      clsTD ="e_square_center e_squere_nd";
                                                                                 if(dd.wolne == '1')  clsTD ="e_square_center e_squere_free";

                                                                                 if(dd.dzien == strToDay)     clsTD = clsTD + " e_squere_today ";

                                                                                 if( !(dd.w == '6' || dd.w == '0' || dd.wolne == '1' ) )
                                                                                    {

                                                                                        if(dd.nb == '1') //nieboecny 
                                                                                            {
                                                                                                razemNB = razemNB + 1;

                                                                                                infoDay = infoDay +  "Nieobecność<br/>";

                                                                                                clsSquare = "e_nb";//  // "e_nbpc";
                                                                                            }
                                                                                            

                                                                                            if(dd.nb == '2') //obecny
                                                                                            {          
                                                                                                   clsSquare = "e_ob";//  // "e_nbpc";                                                                                     
                                                                                                    razemOB = razemOB + 1;                                                                                                        
                                                                                                    iloscRoz = iloscRoz + 1;                                                                                                
                                                                                            } 

                                                                                    }
                                                                              
                                                                                if( (dd.w == '6' || dd.w == '0' || dd.wolne == '1'   ) )    
                                                                                    {
                                                                                        return (
                                                                                            <td className={clsTD}>
                                                                                                                                                                                 
                                                                                            </td>
                                                                                        )
                                                                                    }                                                                           

                                                                           

                                                                                infoDay = row.imie+" " + row.nazwisko + "<br/>" +  infoDay +  "<br/>"
                                                                               


                                                                                return (
                                                                                    <td className={clsTD}  >                                                                                                                                                                         
                                                                                         {
                                                                                                dd.nb == '1' && 
                                                                                                <Fragment>NB</Fragment>
                                                                                            }  
                                                                                            {
                                                                                                dd.nb == '2' &&
                                                                                                <Fragment>OB</Fragment>
                                                                                            } 
                                                                                    </td>
                                                                                )
                                                                            } )

                                                                           
                                                                           
                                                                        }

                                                                        <td className="gocenter e_nb_txt" >{razemNB}</td>
                                                                        <td className="gocenter">{razemOB}</td>

                                                                       
                                                                            
                                                                       

                                                                    </tr>
                                                                )

                                                            } )
                                                        }

 

                                                </tbody>

                                        </table>
                            </div>


                                    <table className="table" >


                                                <thead>
                                                    <tr className="header">
                                                        <td className="td_left">LP</td>                                                 
                                                        <td>Dziecko</td>  
                                                        
                                                       

                                                        {
                                                            tab.map( (row, ix) => {

                                                                if(ix > 0) return null;

                                                                return (
                                                                    row.dni.map( (dd, id) => {
                                                                        return (
                                                                            <td>{id+1}</td>
                                                                        )
                                                                    } )
                                                                )
                                                              

                                                            } )
                                                        }

                                                        <td>NB</td>
                                                        <td>OB</td>
                                                     

                                                    </tr>
                                                </thead>
                                                
                                                <tbody>

                                                        {
                                                  

                                                            tab.map( (row, ix) => {

                                                                var razemNB = 0;
                                                                var razemOB = 0;       
                                                                
                                                                var iloscRoz   = 0;
                                                                var razemKwota = 0;


                                                                var rowStyle = " row ";
                                                                if(ix % 2 == 0 )rowStyle = " row2 ";


                                                                return (
                                                                    <tr className={rowStyle}>
                                                                        <td className="gocenter">{ix+1}</td>                                                  
                                                                        <td>{row.nazwisko + " " + row.imie}</td>                                                                     
                                                                      
                                                                        {
                                                                            row.dni.map( (dd, id) => {

                                                                                var clsTD = " e_square_center ";
                                                                                var clsSquare = "e_ob_def";

                                                                                var infoDay = "Dzień: " + dd.dzien + "<br/><br/>";


                                                                                 if(dd.w == '6')      clsTD ="e_square_center e_squere_sb";
                                                                                 if(dd.w == '0')      clsTD ="e_square_center e_squere_nd";
                                                                                 if(dd.wolne == '1')  clsTD ="e_square_center e_squere_free";

                                                                                 if(dd.dzien == strToDay)     clsTD = clsTD + " e_squere_today ";

                                                                                 if( !(dd.w == '6' || dd.w == '0' || dd.wolne == '1' ) )
                                                                                    {

                                                                                        if(dd.nb == '1') //nieboecny 
                                                                                            {
                                                                                                razemNB = razemNB + 1;

                                                                                                infoDay = infoDay +  "Nieobecność<br/>";

                                                                                                clsSquare = "e_nb";//  // "e_nbpc";
                                                                                            }
                                                                                            

                                                                                            if(dd.nb == '2') //obecny
                                                                                            {          
                                                                                                   clsSquare = "e_ob";//  // "e_nbpc";                                                                                     
                                                                                                    razemOB = razemOB + 1;                                                                                                        
                                                                                                    iloscRoz = iloscRoz + 1;                                                                                                
                                                                                            } 

                                                                                    }
                                                                              
                                                                                if( (dd.w == '6' || dd.w == '0' || dd.wolne == '1'   ) )    
                                                                                    {
                                                                                        return (
                                                                                            <td className={clsTD}>
                                                                                                                                                                                 
                                                                                            </td>
                                                                                        )
                                                                                    }                                                                           

                                                                           

                                                                                infoDay = row.imie+" " + row.nazwisko + "<br/>" +  infoDay +  "<br/>"
                                                                               


                                                                                return (
                                                                                    <td className={clsTD}  >
                                                                                        <span className={"e_squere txtcloud " + clsSquare } status={dd.nb}   dzien={dd.dzien} p_typy_oplat_id={row.p_typy_oplat_id}  p_dziecko_id={row.p_dziecko_id} onClick={zmienStatus}  >
                                                                                            <span className="info_content">
                                                                                               <span className="info_cloud shadowx" dangerouslySetInnerHTML={{__html: infoDay}}   >                                                                                                  
                                                                                               </span>
                                                                                            </span>                                                                                        
                                                                                        </span>                                                                                   
                                                                                    </td>
                                                                                )
                                                                            } )

                                                                           
                                                                           
                                                                        }

                                                                        <td className="gocenter e_nb_txt" >{razemNB}</td>
                                                                        <td className="gocenter">{razemOB}</td>

                                                                       
                                                                            
                                                                       

                                                                    </tr>
                                                                )

                                                            } )
                                                        }

 

                                                </tbody>

                                        </table>
                            </div>




    </div>
}

export default FreePl;